import GridSystem2 from '../../GridSystem2';
import './NewPortalPage.css';
import React, { useState, useEffect } from 'react';
import './NewPortalPreview.css';
import CustomDatePicker from '../helpers/CustomDatePicker_V2';
import { useNavigate } from 'react-router-dom';
import {
    readPortalPage,
    updatePortalPage,
    promoteDraft,
} from '../../services/portalPageService';
import { SecurityAttributes } from '../../utils/data/enums';
import { useAuthContext } from '../../store/AuthContext';
import { hasContainerOverlap } from '../../utils/overlapUtils';
import '../notifications/ScheduleTab.css';
import DatePicker from 'react-datepicker';
import { getMonth, getYear, parse, isValid } from 'date-fns';
import range from 'lodash/range';
import { Dropdown } from '../helpers/Dropdown';
import Toast from '../ui/toasts/Toast';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
const PublishTab = ({
    handleOnClickPrevious,
    savedPage,
    isActivePage = false,
    hasDraft = false,
    livePage = null,
    onDiscardDraft = null,
    hasOverlap = false,
}) => {
    const navigate = useNavigate();

    const { hasAttribute } = useAuthContext();

    const years = range(getYear(new Date()), getYear(new Date()) + 2, 1);
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    const [timezones, setTimezones] = useState([]);

    const [times, setTimes] = useState([]);

    function getDefaultTimezone() {
        if (!timezones || !timezones.length) return null;
        try {
            const userTimeZone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;
            const matchingTimezone = timezones?.find(
                tz =>
                    `${tz.value}`.toLowerCase() ===
                    `${userTimeZone}`.toLowerCase(),
            );
            return matchingTimezone
                ? matchingTimezone.label
                : timezones[0].label;
        } catch (e) {
            return null;
        }
    }

    useEffect(() => {
        setTimes([
            { label: getText('msg_e3b82040565b'), value: 'Now' },
            { label: getText('msg_4c037a2a229f'), value: '7:00 AM' },
            { label: getText('msg_81d5ef12c661'), value: '7:30 AM' },
            { label: getText('msg_164499b35d78'), value: '8:00 AM' },
            { label: getText('msg_c17afe5763d8'), value: '8:30 AM' },
            { label: getText('msg_6e94c98b13aa'), value: '9:00 AM' },
            { label: getText('msg_3d2ba620f372'), value: '9:30 AM' },
            { label: getText('msg_84c6cc90236c'), value: '10:00 AM' },
            { label: getText('msg_7d98bdd5805c'), value: '10:30 AM' },
            { label: getText('msg_7f1dccc12bed'), value: '11:00 AM' },
            { label: getText('msg_5b5692020d53'), value: '11:30 AM' },
            { label: getText('msg_bf413e4bb901'), value: '12:00 PM' },
            { label: getText('msg_4e3236b80493'), value: '12:30 PM' },
            { label: getText('msg_a107f5d9846c'), value: '1:00 PM' },
            { label: getText('msg_c911b2b9856d'), value: '1:30 PM' },
            { label: getText('msg_39a09492964a'), value: '2:00 PM' },
            { label: getText('msg_3e04b92c0151'), value: '2:30 PM' },
            { label: getText('msg_6d3a2fe03484'), value: '3:00 PM' },
            { label: getText('msg_b7323649a306'), value: '3:30 PM' },
            { label: getText('msg_3b9991cb1202'), value: '4:00 PM' },
            { label: getText('msg_dfd2db25a6d1'), value: '4:30 PM' },
            { label: getText('msg_c5359890c05c'), value: '5:00 PM' },
            { label: getText('msg_21894e508298'), value: '5:30 PM' },
            { label: getText('msg_f5dba62a0d63'), value: '6:00 PM' },
            { label: getText('msg_197ea55b13b5'), value: '6:30 PM' },
            { label: getText('msg_875f3c32b6fd'), value: '7:00 PM' },
            { label: getText('msg_5ca86c17fcba'), value: '7:30 PM' },
            { label: getText('msg_c81e339f1483'), value: '8:00 PM' },
            { label: getText('msg_d3475f621187'), value: '8:30 PM' },
            { label: getText('msg_be3259df3c64'), value: '9:00 PM' },
            { label: getText('msg_7f58e7f21041'), value: '9:30 PM' },
            { label: getText('msg_a7a1deb8abbb'), value: '10:00 PM' },
            { label: getText('msg_6944e330e692'), value: '10:30 PM' },
            { label: getText('msg_a81f1d62d68f'), value: '11:00 PM' },
            { label: getText('msg_cae833178b57'), value: '11:30 PM' },
            { label: getText('msg_700bfe2b53f2'), value: '12:00 AM' },
            { label: getText('msg_e0ef000353ba'), value: '12:30 AM' },
            { label: getText('msg_7f9f3db6be19'), value: '1:00 AM' },
            { label: getText('msg_7b93d3bf042d'), value: '1:30 AM' },
            { label: getText('msg_9b4cd6efec02'), value: '2:00 AM' },
            { label: getText('msg_821660db6237'), value: '2:30 AM' },
            { label: getText('msg_0182aeda4477'), value: '3:00 AM' },
            { label: getText('msg_6a49816cba0d'), value: '3:30 AM' },
            { label: getText('msg_7380a788b3f7'), value: '4:00 AM' },
            { label: getText('msg_61392ce437fb'), value: '4:30 AM' },
            { label: getText('msg_56c19b36504d'), value: '5:00 AM' },
            { label: getText('msg_6dd910da01ef'), value: '5:30 AM' },
            { label: getText('msg_832a892adbd3'), value: '6:00 AM' },
            { label: getText('msg_e5c105842a17'), value: '6:30 AM' },
        ]);
        setTimezones([
            { label: getText('msg_e1acb4f52a7a'), value: 'America/New_York' },
            { label: getText('msg_91b79ee5e078'), value: 'America/Chicago' },
            { label: getText('msg_477f7cb7d608'), value: 'America/Denver' },
            { label: getText('msg_d07cb05f55a7'), value: 'America/Phoenix' },
            { label: getText('msg_2856e8edb8d9'), value: 'America/Los_Angeles' },
            { label: getText('msg_be9294933972'), value: 'America/Anchorage' },
            { label: getText('msg_c2b265b1776e'), value: 'Pacific/Honolulu' },
            {
                label: getText('msg_7f969f4e765b'),
                value: 'America/Puerto_Rico',
            },
            { label: getText('msg_f4e031163e8e'), value: 'Pacific/Guam' },
            { label: getText('msg_34589e2a8b67'), value: 'Pacific/Pago_Pago' },
            { label: getText('msg_b1fb3b41beff'), value: 'Pacific/Wake' },
        ]);
    }, []);

    useEffect(() => {
        const currentTimezone = getDefaultTimezone();
        if (currentTimezone) setSelectedTimezone(currentTimezone);
    }, [timezones]);

    const handlePrevious = () => {
        handleOnClickPrevious();
    };

    const handlePublish = () => {
        if (isActivePage && hasDraft) {
            const updatedDraft = {
                id: savedPage.id,
                publishDate: formatDateTime(),
            };
            updatePortalPage(updatedDraft)
                .then(() => {
                    Toast.success(getText('msg_1224b758393b'));
                    navigate(ROUTES.PORTAL_PAGES);
                })
                .catch(() => {
                    Toast.error(
                        getText('msg_f1e8e0364e4a'),
                    );
                });
            return;
        }

        const updatedPage = {
            id: savedPage.id,
            status: checkDateTime(),
            publishDate: formatDateTime(),
        };
        updatePortalPage(updatedPage).then(() => {
            navigate(ROUTES.PORTAL_PAGES);
        });
    };

    function formatDateTime() {
        const date = new Date(selectedDate);

        if (selectedTime === 'Now') {
            const currentTime = new Date();
            date.setHours(currentTime.getHours());
            date.setMinutes(currentTime.getMinutes());
            date.setSeconds(currentTime.getSeconds());
            date.setMilliseconds(currentTime.getMilliseconds());
        } else {
            const timeParts = selectedTime.split(' ');
            let [hour, minute] = timeParts[0].split(':').map(Number);
            const isPM = timeParts[1] === 'PM';

            if (isPM && hour < 12) {
                hour += 12;
            } else if (!isPM && hour === 12) {
                hour = 0;
            }
            date.setHours(hour);
            date.setMinutes(minute);
        }

        // Return the formatted date in ISO format
        return date.toISOString();
    }

    function checkDateTime() {
        const today = new Date();
        const publishDate = new Date(selectedDate);

        // If the selected date is in the future, return Pending status
        if (publishDate > today) {
            return 4;
        }

        // If the selected date is today and the selected time is "Now", return Active status
        if (
            publishDate.toDateString() === today.toDateString() &&
            selectedTime === 'Now'
        ) {
            return 1;
        }

        // For current date and future time, return Pending status
        return 4;
    }

    const getCurrentTime = () => {
        const currentTime = new Date();
        const hour = currentTime.getHours();
        const minutes = currentTime.getMinutes();
        return { hour: hour, minutes: minutes };
    };

    const getSelectedDateFromPublishDate = publishDateValue => {
        if (!publishDateValue) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        }

        if (publishDateValue instanceof Date) {
            return isValid(publishDateValue) ? publishDateValue : undefined;
        }

        if (typeof publishDateValue === 'string') {
            if (/^\d{4}-\d{2}-\d{2}$/.test(publishDateValue)) {
                const parsedDate = parse(
                    publishDateValue,
                    'yyyy-MM-dd',
                    new Date(),
                );
                return isValid(parsedDate) ? parsedDate : undefined;
            }

            const parsedDate = new Date(publishDateValue);
            return isValid(parsedDate) ? parsedDate : undefined;
        }

        return undefined;
    };

    const [selectedDate, setSelectedDate] = useState(() =>
        getSelectedDateFromPublishDate(savedPage.publishDate),
    );
    const [selectedTime, setSelectedTime] = useState('Now');
    const [time, setTime] = useState(getCurrentTime());
    const [selectedTimezone, setSelectedTimezone] =
        useState('Eastern Time (ET)');
    const [isPublished, setIsPublished] = useState(
        (savedPage.status === 1 || savedPage.status === 2) &&
            !(isActivePage && hasDraft),
    );

    const [computedOverlap, setComputedOverlap] = useState(false);

    useEffect(() => {
        const portalId = savedPage?.id;
        if (!portalId) return;

        readPortalPage(portalId, true)
            .then(data => {
                const containers = data?.containers ?? [];
                setComputedOverlap(hasContainerOverlap(containers));
            })
            .catch(() => {
                setComputedOverlap(false);
            });
    }, [savedPage?.id]);

    const isBlocked = computedOverlap;

    useEffect(() => {
        setSelectedDate(getSelectedDateFromPublishDate(savedPage.publishDate));
        setIsPublished(
            (savedPage.status === 1 || savedPage.status === 2) &&
                !(isActivePage && hasDraft),
        );
    }, [savedPage.publishDate, savedPage.status, isActivePage, hasDraft]);

    const handleOnClickDate = date => {
        if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
            setSelectedDate(isValid(parsedDate) ? parsedDate : undefined);
            return;
        }

        setSelectedDate(date);
    };

    const handleTimezoneChange = selectedOption => {
        setSelectedTimezone(selectedOption);
    };

    const handleTimeChange = selectedOption => {
        setSelectedTime(selectedOption);
        switch (selectedOption) {
            case 'Now':
                setTime(getCurrentTime());
                break;
            default:
                let hour = '';
                let minutes = '';
                const timeParts = selectedOption.split(':');
                hour = parseInt(timeParts[0]);
                minutes = parseInt(timeParts[1].split(' ')[0]);
                const isPM = timeParts[1].split(' ')[1] === 'PM';
                const hour24 = isPM ? hour + 12 : hour;
                setTime({ hour: hour24, minutes: minutes });
        }
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    overflowX: 'auto',
                    padding: '20px',
                }}
            >
                {/* Overlap warning banner removed; handled via Toast on navigation */}
                {/* Main DatePicker */}
                <div className="col-7 m-auto pb-5">
                    <div className="customDatePickerWidth">
                        <DatePicker
                            readOnly={isPublished || isBlocked}
                            disabled={isPublished || isBlocked}
                            selected={selectedDate}
                            calendarClassName={
                                isPublished || isBlocked
                                    ? 'react-datepicker-wrapper-disabled'
                                    : 'react-datepicker-wrapper'
                            }
                            onChange={
                                isPublished || isBlocked
                                    ? null
                                    : date => handleOnClickDate(date)
                            }
                            dateFormat={[
                                'EEEE, MMM dd yyyy',
                                'MM-dd-yyyy',
                                'MM/dd/yyyy',
                                'MMM dd yyyy',
                            ]}
                            formatWeekDay={nameOfDay => nameOfDay.substr(0, 3)}
                            minDate={new Date()}
                            maxDate={
                                new Date(
                                    new Date().getFullYear(),
                                    new Date().getMonth() + 12,
                                    new Date().getDate(),
                                )
                            }
                            inline
                            renderCustomHeader={({
                                date,
                                changeMonth,
                                changeYear,
                                decreaseMonth,
                                increaseMonth,
                                increaseYear,
                                decreaseYear,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                            }) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px',
                                        gap: '10px',
                                        borderBottom:
                                            '1px solid rgba(222, 226, 230, 1)',
                                    }}
                                >
                                    {/* Navigation buttons */}
                                    <i
                                        className="bi bi-chevron-double-left"
                                        style={{
                                            color: 'rgba(206, 212, 218, 1)',
                                        }}
                                        onClick={decreaseYear}
                                        disabled={prevMonthButtonDisabled}
                                    />
                                    <i
                                        className="bi bi-chevron-left"
                                        style={{
                                            color: 'rgba(206, 212, 218, 1)',
                                        }}
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                    />

                                    {/* Month select */}
                                    <div
                                        className="custom-select-wrapper"
                                        style={{ marginLeft: 'auto' }}
                                    >
                                        <select
                                            value={months[getMonth(date)]}
                                            onChange={({ target: { value } }) =>
                                                changeMonth(
                                                    months.indexOf(value) + 1,
                                                )
                                            }
                                        >
                                            {months.map(option => (
                                                <option
                                                    key={option}
                                                    value={option}
                                                >
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Year select */}
                                    <div
                                        className="custom-select-wrapper"
                                        style={{ marginRight: 'auto' }}
                                    >
                                        <select
                                            value={getYear(date)}
                                            onChange={({ target: { value } }) =>
                                                changeYear(parseInt(value))
                                            }
                                        >
                                            {years.map(option => (
                                                <option
                                                    key={option}
                                                    value={option}
                                                >
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Navigation buttons */}
                                    <i
                                        className="bi bi-chevron-right"
                                        style={{
                                            color: 'rgba(206, 212, 218, 1)',
                                        }}
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                    />
                                    <i
                                        className="bi bi-chevron-double-right"
                                        style={{
                                            color: 'rgba(206, 212, 218, 1)',
                                        }}
                                        onClick={increaseYear}
                                        disabled={nextMonthButtonDisabled}
                                    />
                                </div>
                            )}
                        />
                    </div>
                    <div className="pt-5" style={{ display: 'flex' }}>
                        <div
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                paddingRight: '10px',
                            }}
                        >
                            <div className="file-form-label">
                                {getText('msg_eb9a4bc1c0c1')}
                                <span
                                    style={{
                                        color: '#EF4E45',
                                        marginLeft: '4px',
                                        fontWeight: '500',
                                    }}
                                >
                                    *
                                </span>
                            </div>
                            <CustomDatePicker
                                disabled={isPublished || isBlocked}
                                selectedDate={selectedDate}
                                onDateChange={date => handleOnClickDate(date)}
                                displayFormat="EEEE, MMM dd yyyy"
                                minDate={new Date()}
                            />
                        </div>
                        <div
                            style={{
                                flex: 0.7,
                                display: 'flex',
                                flexDirection: 'column',
                                paddingRight: '10px',
                            }}
                        >
                            <div className="file-form-label">
                                {getText('msg_6c82e6dd8680')}
                                <span
                                    style={{
                                        color: '#EF4E45',
                                        marginLeft: '4px',
                                        fontWeight: '500',
                                    }}
                                >
                                    *
                                </span>
                            </div>
                            <Dropdown
                                disabled={isPublished || isBlocked}
                                defaultValue={selectedTime}
                                options={times}
                                onChange={handleTimeChange}
                            />
                        </div>
                        <div
                            style={{
                                flex: 0.7,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <div className="file-form-label">
                                {getText('msg_d1f7dc891b5e')}
                                <span
                                    style={{
                                        color: '#EF4E45',
                                        marginLeft: '4px',
                                        fontWeight: '500',
                                    }}
                                >
                                    *
                                </span>
                            </div>
                            <Dropdown
                                disabled={isPublished || isBlocked}
                                defaultValue={selectedTimezone}
                                options={timezones}
                                onChange={handleTimezoneChange}
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginTop: '60px',
                        }}
                    >
                        <div
                            onClick={handlePrevious}
                            type="button"
                            className="navigation-button float-start button-base button-secondary ing-popup-blue-negative"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="33"
                                viewBox="0 0 20 33"
                                fill="none"
                                style={{ marginRight: '8px' }} // Adjust margin as needed
                            >
                                <path
                                    d="M16 10.3484L10.0066 16.022L16.0132 21.6817"
                                    stroke="#2F2B43"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {getText('msg_50f94286ba30')}
                        </div>

                        {!hasAttribute(SecurityAttributes.PortalsReadOnly) && (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                }}
                            >
                                <div
                                    onClick={
                                        isBlocked
                                            ? null
                                            : isActivePage && hasDraft
                                              ? handlePublish
                                              : isPublished
                                                ? null
                                                : handlePublish
                                    }
                                    style={{
                                        marginLeft: '8px',
                                        fontSize: '14px',
                                        cursor:
                                            isBlocked ||
                                            (!isActivePage &&
                                                !hasDraft &&
                                                isPublished)
                                                ? 'not-allowed'
                                                : 'pointer',
                                        opacity: isBlocked ? 0.5 : 1,
                                    }}
                                    type="button"
                                    className={`navigation-button button-base ing-button-primary-left ${
                                        isBlocked ||
                                        (!isActivePage &&
                                            !hasDraft &&
                                            isPublished)
                                            ? 'disabled'
                                            : ''
                                    }`}
                                >
                                    {getText('msg_5656400564f2')}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PublishTab;
